<template>
  <div class="form-group">
    <label v-if="label"
           :for="id"
           v-bind:class="{required: hasRequired}">
      {{label}}
    </label>
    <div class="input-group">
      <input v-bind:value="value"
             v-on="inputListeners"
             :id="id"
             class="form-control"
             v-mask="mask"
             :aria-label="label"
             v-bind:placeholder="$attrs.placeholder || label"
             v-bind="$attrs"
             v-bind:class="{ 'is-invalid': validation.$error }"/>
      <div class="invalid-feedback">
        {{errorMessage}}
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationMixin } from '@/js/Mixins';

export default {
  name: 'BaseInput',
  mixins: [ValidationMixin],
  inheritAttrs: false,
  props: {
    value: [String, Number],
    mask: {
      type: String,
      default: '',
    },
  },
  mounted() {
    this.id = `input-${this._uid}`;
  },
  data() {
    return {
      id: null,
    };
  },
  computed: {
    inputListeners() {
      const vm = this;
      return Object.assign({}, this.$listeners, {
        input(event) {
          vm.validation.$touch();
          vm.$emit('input', event.target.value);
        },
      });
    },
  },
};
</script>

<style lang="scss">
  .form-control {
    min-width: 75px;
  }
</style>
